// Central config. Values are filled from the deployed backend (amplify push
// outputs) via .env — REACT_APP_* vars are baked at build time by CRA.
const config = {
  region: process.env.REACT_APP_AWS_REGION || 'eu-west-2',
  userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
  userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || '',
  cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN || 'cadence-prod.auth.eu-west-2.amazoncognito.com',
  apiEndpoint: process.env.REACT_APP_API_BASE_URL || '',
  // cadenceBrainStream Function URL (SSE briefing + chat). From the
  // cadenceBrain CFN stack's StreamFunctionUrl output after amplify push.
  assistantStreamUrl: process.env.REACT_APP_ASSISTANT_STREAM_URL || '',
  publicOrigin: 'https://cadence.wolftechnologies.co.uk',
};

export default config;
